<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Agents',
                link: {
                    name: 'AI Usage Agents',
                },
            },
            {
                name: 'MCP',
                link: {
                    name: 'AI Usage MCP',
                },
            },
        ]" title="AI Usage" pretitle="Administration">
            <template v-slot:breadcrumb-title>
                <nav aria-label="breadcrumb" class="header-title">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#" class="h1">AI Usage</a></li>
                    </ol>
                </nav>
            </template>
            <template v-slot:header-button-content>
                <button class="btn btn-primary" @click="getUsageData(true)" :disabled="loading">
                    <div v-if="loading" class="spinner-border spinner-border-sm me-1" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                    <i v-else class="fa fa-refresh"></i>
                    Refresh
                </button>
            </template>
        </nav-header>
        <div>
            <router-view :agentsLoading="agentsLoading" :mcpLoading="mcpLoading" @getUsageData="getUsageData">
            </router-view>
        </div>
    </div>
</template>
<script>
import NavHeader from '../../components/NavHeader.vue';
import { mapActions } from "vuex";
export default {
    components: { NavHeader },
    data() {
        return {
            loading: false,
            agentsLoading: false,
            mcpLoading: false,
        }
    },
    methods: {
        ...mapActions({
            fetchAgentsUsageData: "admin/fetchAgentsUsageData",
            fetchMcpUsageData: "admin/fetchMcpUsageData",
        }),
        async getUsageData(forceGet = false) {
            this.loading = true;
            try {
                if (this.$route.name === "AI Usage Agents") {
                    if (!forceGet && !!this.$store.state.admin.agentsUsageData && !!this.$store.state.admin.agentsUsageData.daily && !!this.$store.state.admin.agentsUsageData.aggregate) {
                        return;
                    }
                    this.agentsLoading = true;
                    await this.fetchAgentsUsageData("daily");
                    await this.fetchAgentsUsageData("aggregate");
                    this.agentsLoading = false;
                } else if (this.$route.name === "AI Usage MCP") {
                    if (!forceGet && !!this.$store.state.admin.mcpUsageData && !!this.$store.state.admin.mcpUsageData.daily && !!this.$store.state.admin.mcpUsageData.aggregate) {
                        return;
                    }
                    this.mcpLoading = true;
                    await this.fetchMcpUsageData("daily");
                    await this.fetchMcpUsageData("aggregate");
                    this.mcpLoading = false;
                }
            } catch (error) {
                console.error(error);
                this.$store.dispatch('addToast', {
                    message: "Failed to fetch usage data. Please contact support.",
                    type: 'error'
                });
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>